import { Inject, Injectable } from '@angular/core';
import {JSON_FORM_ENDPOINT, JSON_FORM_QUERY_SERVICE_INSTANCE} from '../survey.config';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from '../../../../core/services/snackbar-psa.service';  // Import MatSnackBar
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { CrudFluxService } from 'src/app/core/services/crud-flux.service';
import { ApiFluxService } from 'src/app/core/services/api-flux.service';


@Injectable({
  providedIn: 'root'
})
export class SurveyJsonFormFluxService extends CrudFluxService<any> {

  constructor(
    @Inject(JSON_FORM_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
    public readonly apiService:ApiFluxService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(JSON_FORM_ENDPOINT, apiService, snackbar);
  }


}
